import gql from 'graphql-tag';

export const CREATE_BULK_TERMS_MUTATION = gql`
mutation CreateBulkTermsMutation($programId: Int!, $projectInput: TermsProjectInput!, $memberDetails: [TermsMemberDetailsInput!]! $fromErrorState: Boolean!, $termsType: TermsType!) {
  success: sendBulkTerms(programId: $programId, projectInput: $projectInput, memberDetails: $memberDetails, fromErrorState: $fromErrorState, termsType: $termsType)
  }
`;
